module.exports = __webpack_public_path__ + "img/cover_twitter.png";